<template lang="pug">
div
  template(v-if="isFetching")
    v-skeleton-loader.pb-2(type="text")
    v-skeleton-loader.pb-2(type="text")
    v-skeleton-loader.pb-2(type="text")
    v-skeleton-loader.pb-2(type="text")
    v-skeleton-loader.pb-2(type="text")
    v-skeleton-loader(type="text")
  template(v-else)
    //- Top Tabs
    v-row.pb-2.pb-md-0(no-gutters)
      v-col
        v-tabs(v-model="tab" color="basic700" :height="44" :grow="isMobileScreen" show-arrows active-class="font-semibold")
          v-tab.text-sm.font-medium.text-none.px-4(v-for="status in statuses" :key="status") {{ status }}
    v-divider
    //- Tab listing
    v-tabs-items(v-model="tab" style="overflow: unset;")
      template(v-if="subscribeCms")
        v-tab-item
          profile-visit-tab(:key="visitKey" @updated="onUpdateVisit")
        v-tab-item
          profile-document-tab(:key="documentKey" @updated="onUpdateDocument")
        v-tab-item
          profile-file-tab(:key="fileKey")
        v-tab-item
          profile-billing-tab
        v-tab-item
          div.text-md.font-semibold.mt-8.mb-4 Family
          family-listing(:patientId="patientId")
      v-tab-item
        profile-appointment-tab
      template(v-if="subscribeCms")
        v-tab-item
          profile-reservation-tab
        v-tab-item
          profile-preorder-tab
</template>

<script>
import { isServerSide } from '@/utils'
import { mapState } from 'vuex'
import ProfileVisitTab from '@/components/clinic/patient/tabs/ProfileVisitTab.vue'
import ProfileDocumentTab from '@/components/clinic/patient/tabs/ProfileDocumentTab.vue'
import ProfileFileTab from '@/components/clinic/patient/tabs/ProfileFileTab.vue'
import ProfileBillingTab from '@/components/clinic/patient/tabs/ProfileBillingTab.vue'
import ProfileAppointmentTab from '@/components/clinic/patient/tabs/ProfileAppointmentTab.vue'
import ProfileReservationTab from '@/components/clinic/patient/tabs/ProfileReservationTab.vue'
import ProfilePreorderTab from '@/components/clinic/patient/tabs/ProfilePreorderTab.vue'
import FamilyListing from '@/components/clinic/relationship/FamilyListing.vue'

export default {
  components: {
    ProfileVisitTab, ProfileDocumentTab, ProfileFileTab, ProfileBillingTab, ProfileAppointmentTab, ProfileReservationTab, ProfilePreorderTab, FamilyListing
  },
  data() {
    return {
      visitKey: 0,
      documentKey: 0,
      fileKey: 0,
      tab: null,
      isFetching: false,
      subscribeCms: false
    }
  },
  watch: {
    tab(newValue) {
      if (this.isFetching) return
      const paramName = this.statuses[newValue].toLowerCase()
      let query = {
        tab: paramName
      }
      if (this.$route.query?.leadPid) {
        query.leadPid = this.$route.query.leadPid
      }
      if (paramName === 'billings' && this.$route.query?.subtab) {
        query.subtab = this.$route.query?.subtab
      }
      this.$router.push({ query }).catch(() => {})
    }
  },
  async mounted () {
    if (isServerSide) {
      await this.fetchPermission()
    } else {
      this.subscribeCms = this.Auth('root', 'subscribe_cms')
    }
    this.checkQuery()
  },
  computed: {
    ...mapState('user', ['member']),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    statuses () {
      let statuses = ['Appointments']
      if (this.subscribeCms) {
        statuses.splice(0, 0, 'Visits', 'Documents', 'Files', 'Billings', 'Family')
        statuses.push('Reservations', 'Pre-orders')
      }

      return statuses
    },
    patientId () {
      const id = this.$route.params?.id
      if (id) {
        return parseInt(id)
      }
      return null
    }
  },
  methods: {
    checkQuery () {
      const tab = this.$route.query?.tab || null
      if (tab) {
        const index = this.statuses.findIndex(status => status.toLowerCase() === tab.toLowerCase())
        if (index >= 0) {
          this.tab = index
        }
      }
    },
    onUpdateVisit () {
      this.documentKey++
      this.fileKey++
    },
    onUpdateDocument () {
      this.visitKey++
    },
    async fetchPermission () {
      try {
        this.isFetching = true
        const { data } = await this.$axios.get(`/members/${this.member.id}/permissions`)
        this.subscribeCms = data.root.subscribe_cms
      // eslint-disable-next-line no-empty
      } catch (error) {

      } finally {
        this.isFetching = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>